import { Button, Grid } from '@mui/material';
import React, { FC } from 'react';
import { FormTextInput } from 'src/components/FormPart/FormTextInput';
import { FormComponentProps } from 'src/components/FormPart/types';
import { BlocklistEntryFormData } from '../../types';

type BlocklistEntryFormProps = object;

export const BlocklistEntryForm: FC<
  FormComponentProps<BlocklistEntryFormData, BlocklistEntryFormProps>
> = props => {
  const { form } = props;

  const { id } = form.watch();

  return (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <FormTextInput
          form={form}
          fieldName="word"
          label="Word/Phrase"
          placeholder="Enter word or phrase"
          validation={{
            required: 'Word/Phrase is required',
          }}
        />
      </Grid>

      <Grid item xs={12} display="flex" justifyContent="flex-end">
        <Button
          type="submit"
          disabled={form.formState.isSubmitting || !form.watch('word')?.trim()}
          variant="contained"
          color="secondary"
          size="large"
        >
          {id ? 'Update' : 'Add to Blocklist'}
        </Button>
      </Grid>
    </Grid>
  );
};
